module.exports = "/static/assets/02ba94a0effe2277def1038341d652d7.png";